import "./Footer.scss";

const Footer = () => {
  return (
    <div id="footer_wrap">
      <div className="footer">
        Copyrightⓒ 2025 Hyundai Motor Company All rights reserved.
      </div>
    </div>
  );
};

export default Footer;
